import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Text } from 'rebass';
import { FaCircleCheck } from 'react-icons/fa6';

// Shown after a gift certificate email is (re)sent. Delivery isn't instant, so this
// manages that expectation rather than implying the email is already in the inbox.
const GiftCertificateSuccessMessage = ({ onContinue, continueLabel, minHeight, mt }) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    minHeight={minHeight}
    p={4}
    mt={mt}
    width="100%"
    maxWidth="600px"
    mx="auto"
  >
    <FaCircleCheck size={60} color="#C2FFD3" style={{ marginBottom: 16 }} />
    <Text
      fontSize={[26, 30]}
      fontFamily="Bitter"
      color="#0E0E0E"
      textAlign="center"
      lineHeight={"120%"}
      mb={2}
    >
      Gift Certificate is being sent
    </Text>
    <Text
      fontFamily="Poppins"
      color="#64748B"
      textAlign="center"
      fontSize={18}
      mb={4}
    >
      It may take a couple of minutes to appear in your inbox. Please check your spam folder just in case.
    </Text>
    <Button
      onClick={onContinue}
      px={4}
      py={3}
      sx={{
        borderRadius: 'medium',
        fontSize: 16,
        fontWeight: 600,
        fontFamily: 'Poppins',
        cursor: 'pointer',
      }}
    >
      {continueLabel}
    </Button>
  </Flex>
);

GiftCertificateSuccessMessage.propTypes = {
  onContinue: PropTypes.func.isRequired,
  continueLabel: PropTypes.string,
  minHeight: PropTypes.string,
  mt: PropTypes.number,
};

GiftCertificateSuccessMessage.defaultProps = {
  continueLabel: 'Continue to My Account',
  minHeight: '100vh',
  mt: 7,
};

export default GiftCertificateSuccessMessage;
